import getConfiguration from '@/shared/configuration';

export const eventsTurnedOff = (domain: string) => {
  const { eventsTurnedOffDomains } = getConfiguration();
  if (!domain || !eventsTurnedOffDomains) {
    return false;
  }
  return eventsTurnedOffDomains.includes(domain);
};